export enum ITEM_POSITION {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export const STYLE_CARD_3_COLUMNS_CLASS = 'style-card-3-columns';
export const STYLE_CARD_SUBTRACT_HEIGHT = 60 + 56 + 82 + 34 + 66 + 24; // header + footer + chat box + feedback option + shop now button & share/like/dislike + padding
export const DESKTOP_AMIRA_MESSAGE_WIDTH = 400;
